var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) { return ({
    tab: __assign(__assign({ '&:first-child': {
            borderRadius: theme.spacing(1) + "px 0 0 0",
        }, '&:last-child': {
            borderRadius: "0 " + theme.spacing(1) + "px 0 0",
        }, background: theme.palette.grey[100], '&.Mui-selected': {
            color: theme.palette.primary.main,
            opacity: 0.7,
        } }, theme.typography.body1), { fontWeight: theme.typography.fontWeightMedium, paddingBottom: theme.spacing(2.125), paddingTop: theme.spacing(1.875), maxWidth: 'unset', flex: 1, textTransform: 'unset', borderBottom: "1px solid " + theme.palette.grey[200], '& .MuiTab-wrapper': {
            lineHeight: '24px',
            fontSize: '16px',
            letterSpacing: '-0.006em',
        } }),
    page: {
        marginTop: theme.spacing(3),
    },
}); });
